import makeStyles from "@mui/styles/makeStyles";

// The storefront itself is styled inline from utils/designTokens.js; these are
// the loading and food-truck screens around it.
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#FFFFFF",
    minHeight: "100vh",
  },
  spinnerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "60vh",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));

export default useStyles;
